/**
 * Visibilité actions brouillon contrat — aligné contractApprovalContext + statut version.
 */
export function resolveNr2jContractDraftActions({
  isDraft,
  approvalInfo = null,
  approvalStatus = null,
} = {}) {
  const needsApproval = Boolean(approvalInfo?.required);
  const approvalPending = approvalStatus === 'PENDING';
  const approvalGranted = approvalStatus === 'APPROVED';
  const canSubmit = Boolean(approvalInfo?.canSubmit);
  const canSend = Boolean(approvalInfo?.canSend);

  const showSubmitDraft = Boolean(
    isDraft
    && needsApproval
    && !approvalPending
    && !approvalGranted
    && canSubmit,
  );
  const showSendDraft = Boolean(
    isDraft
    && canSend
    && (!needsApproval || approvalGranted),
  );
  const showPendingApproval = Boolean(isDraft && approvalPending);

  return {
    needsApproval,
    approvalPending,
    approvalGranted,
    canSubmit,
    canSend,
    showSubmitDraft,
    showSendDraft,
    showPendingApproval,
  };
}
